var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBookmarkWhite = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49805 5.2C3.49805 4.0799 3.49805 3.51984 3.71603 3.09202C3.90778 2.71569 4.21374 2.40973 4.59007 2.21799C5.01789 2 5.57794 2 6.69805 2H9.63138C10.7515 2 11.3115 2 11.7394 2.21799C12.1157 2.40973 12.4216 2.71569 12.6134 3.09202C12.8314 3.51984 12.8314 4.0799 12.8314 5.2V14L8.16471 11.3333L3.49805 14V5.2Z",
    stroke: "#D1D1D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBookmarkWhite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bookmark-white.a9e5c46a.svg";
export { ForwardRef as ReactComponent };